import { FC } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import style from './ProgressBar.module.scss';

type ProgressBarMonProps = {
  value: number;
};

const ProgressBarMon: FC<ProgressBarMonProps> = ({ value }) => {
  return (
    <div className={style.container}>
      <ProgressBar
        value={value}
        showValue
        className={style.progressBarGradient}
        color="#223466"
        style={{
          width: '100%',
        }}
      />
    </div>
  );
};

export default ProgressBarMon;
